import { render, staticRenderFns } from "./VoiceAssistant.vue?vue&type=template&id=c35bb0d4&scoped=true"
import script from "./VoiceAssistant.vue?vue&type=script&lang=js"
export * from "./VoiceAssistant.vue?vue&type=script&lang=js"
import style0 from "./VoiceAssistant.vue?vue&type=style&index=0&id=c35bb0d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35bb0d4",
  null
  
)

export default component.exports